import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import Video from "components/video";
import collectionMeta from "content/collections/leopard-gecko.json";
import { animalGridFromJson } from "hooks/useGallery";

// Images
// Cotton Sun
// Babies
// Pinta

const animalGridData = animalGridFromJson(collectionMeta);

const LeopardGecko = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Leopard Geckos (Eublepharis macularius)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/leopard-gecko" />
      </Helmet>
      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />
      <AnimalGrid data={animalGridData} />
      <BodyText>
        The leopard geckos in our home have primarily been the interest of my
        youngest son but they are such cool lizards I have gotten into them too.
        Obviously they are everywhere in the pet market but once we started
        holding and interacting with them it was clear what the appeal is. Big
        chunky animals that aren't flighty or wiggly and they come in some
        incredible colors and patterns.
      </BodyText>
      <Video
        src="https://www.youtube.com/embed/_QzD75ldpQM"
        caption="Decorating My Lizard's Cage!"
      />
      <Video
        src="https://www.youtube.com/embed/djHybCWiPhI"
        caption="Leopard Gecko Fixer-Upper!"
      />
      <Video
        src="https://www.youtube.com/embed/D2x8z24oHuQ"
        caption="I Got a New Leopard Gecko!"
      />
      <BodyText>
        We got our first one, Sunset, for my son for a birthday present. He
        picked it out himself at the Las Vegas reptile expo that we went to.
        Sunset is absolutely stunning in color. Over the next few years my son
        bought two female leopard geckos and bred them to Sunset, but we have
        struggled to maintain the health of the females. Both of them passed
        away after laying eggs. Low calcium intake is probably the culprit. The
        deaths have been devastating for us so we're not ready to try and
        correct our husbandry yet with new animals.
      </BodyText>
      <PageGallery slug="leopard-gecko" maxWidth="900" />
    </ContentBox>
  );
};

export default LeopardGecko;
